import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { axiosInit } from "./axios-interceptor";
import VueGtag from "vue-gtag";
import "./main.scss";

axiosInit();

const app = createApp(App);
app.config.productionTip = false;

app.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_ANALYTICS_ID },
    appName: "Rating Disclosure External",
    pageTrackerScreenviewEnabled: true,
  },
  router,
);
app.use(router);
app.mount("#app");
